import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import bg from '../../assets/images/frame100.png'
// import tes from '../../assets/images/romawi.png'
import {ReactComponent as IcArrow} from '../../assets/icons/Right.svg'
import {ReactComponent as IcShoppe} from '../../assets/icons/shoppe.svg'
import {ReactComponent as IcTokped} from '../../assets/icons/tokped.svg'
import  data  from '../../data/staticData'
import "tailwindcss/tailwind.css";


export const FavProduct = () => {
  const [emblaRef, embla] = useEmblaCarousel({ loop: false, align: "start" });
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const updateScrollState = useCallback(() => {
    if (!embla) return;
    setCanScrollPrev(embla.canScrollPrev());
    setCanScrollNext(embla.canScrollNext());
  }, [embla]);


  useEffect(() => {
    if (!embla) return;
    embla.on("select", updateScrollState);
    updateScrollState();
  }, [embla, updateScrollState]);

  return (
    <div className="sm:p-6 md:p-8 lg:p-10 pt-14 w-full h-[35rem] overflow-hidden" style={{ backgroundImage: `url(${bg})` }}>
      <div className="flex items-center justify-between px-4 mb-4">
        <div className="text-left text-white">
          <h2 className="text-base">Best Seller</h2>
          <h6 className="font-semibold text-xl">Pilihan yang Paling Digemari Pelanggan</h6>
        </div>
        <div className="flex gap-2">
          <button
            className={`p-2 bg-white rounded-full ${!canScrollPrev && "opacity-50"} rotate-180`}
            onClick={() => embla && embla.scrollPrev()}
            // disabled={!canScrollPrev}
          >
            <IcArrow className="w-4"/>
          </button>
          <button
            className={`p-2 bg-white rounded-full ${!canScrollNext && "opacity-50"}`}
            onClick={() => embla && embla.scrollNext()}
            // disabled={!canScrollNext}
          >
            <IcArrow className="w-4"/>
          </button>
        </div>
      </div>

      <div className="overflow-hidden h-96" ref={emblaRef}>
        <div className="flex gap-4">
          {data.bestSeller.map((item, index) => (
            <div
              key={index}
              className="min-w-[250px] bg-white rounded-lg shadow-md p-4 text-left"
            >
              <img src={item.image} alt="item" className="rounded-md w-56 h-56" />
              <h3 className="mt-2 text-base font-semibold">{item.name}</h3>
              <p className="text-sm text-gray-600">Inspired by {item.inspiredBy}</p>
              <div className="flex gap-2 mt-2">
                <button 
                  className="flex items-center space-x-1 py-2 px-4 border border-orange-500 text-orange-500 rounded-full text-sm"
                  onClick={() => window.open(item.shoppeUrl)}
                >
                  <IcShoppe />
                  <p>Shopee</p>
                </button>
                <button 
                  className="flex items-center space-x-1 py-2 px-4 border border-[#41B549] text-[#41B549] rounded-full text-sm" 
                  onClick={() => window.open(item.tokpedUrl)}
                >
                  <IcTokped />
                  <p>Tokped</p>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

